import React from 'react';
import { nonShowdownSeries, showdownSeries, totalSeries } from '../data/demoStats';

function polyline(series: number[], color: string, dash = '') {
  const points = series
    .map(
      (value, i) =>
        `${((i * 1000) / (series.length - 1)).toFixed(1)},${(140 - value * 0.065).toFixed(1)}`,
    )
    .join(' ');

  return (
    <polyline
      points={points}
      fill="none"
      stroke={color}
      strokeWidth="2"
      vectorEffect="non-scaling-stroke"
      strokeDasharray={dash || undefined}
    />
  );
}

type V2ChartProps = {
  mini?: boolean;
  factor?: number;
  winnings?: string;
};

const V2Chart: React.FC<V2ChartProps> = ({ mini = false, factor = 1, winnings = '+$332' }) => {
  const total = totalSeries.map((value) => value * factor);
  const sd = showdownSeries.map((value) => value * factor);
  const nsd = nonShowdownSeries.map((value) => value * factor);

  return (
    <svg
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 1000 225"
      preserveAspectRatio="none"
      role="img"
      aria-label={`Иллюстративная динамика результата. Итог ${winnings}.`}
    >
      <title>Демонстрационный график, не история реального игрока</title>
      {[42, 91, 140, 189].map((y) => (
        <path
          key={y}
          d={`M0 ${y}H1000`}
          stroke="var(--line)"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
          strokeDasharray={mini ? undefined : '2 5'}
        />
      ))}
      {polyline(nsd, 'var(--chart-non-showdown)', '4 5')}
      {polyline(sd, 'var(--chart-showdown)')}
      {polyline(total, 'var(--chart-profit)')}
    </svg>
  );
};

export default V2Chart;
